import { createSelector } from 'reselect'

export const getCategoryBySeo = seo => createSelector(
  (state) => state && state.categories && state.categories.bySeo && state.categories.bySeo[seo]
    ? state.categories.bySeo[seo] : null,
  (category) => category
)
